/*
 * Animacion de entrada de la imagen principal del producto (GSAP).
 * Anima la media activa + las miniaturas en cascada.
 */
(function () {
  var PREFERS_REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function reveal(gallery) {
    if (gallery) gallery.classList.add('media-anim-ready');
  }

  function animate() {
    var gallery = document.querySelector('.product__media-wrapper');
    if (!gallery) return;

    // Si GSAP no cargo (CDN caido, adblock), mostramos sin animar
    if (typeof window.gsap === 'undefined') {
      reveal(gallery);
      return;
    }

    reveal(gallery);

    var main = gallery.querySelector('.product__media-item.is-active') ||
               gallery.querySelector('.product__media-item');
    var thumbs = gallery.querySelectorAll('.thumbnail-list__item');

    var tl = window.gsap.timeline({
      defaults: { ease: 'power2.out', duration: 0.7 },
    });

    if (main) {
      tl.from(main, { opacity: 0, y: 24, scale: 0.985, clearProps: 'all' });
    }

    if (thumbs.length) {
      tl.from(
        thumbs,
        { opacity: 0, y: 12, duration: 0.45, stagger: 0.06, clearProps: 'all' },
        '-=0.4'
      );
    }
  }

  function init() {
    // Sin animacion si el usuario pidio menos movimiento: se muestra directo
    if (PREFERS_REDUCED) {
      reveal(document.querySelector('.product__media-wrapper'));
      return;
    }

    if (typeof window.gsap !== 'undefined') {
      animate();
    } else {
      // GSAP carga con defer; esperamos al load si todavia no esta
      window.addEventListener('load', animate, { once: true });
    }

    // Red de seguridad: si algo falla, la imagen nunca queda invisible
    setTimeout(function () {
      reveal(document.querySelector('.product__media-wrapper'));
    }, 2000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
